import rest from "@/rest-client";

/**
 * TKP-27 / Faz 6 dilim 6.3 — dayanak önerileri DÜĞÜM bağlamıyla (TKP-63 / K6): düzenlenen ilgili kişi satırının düğümü
 * (`processData`) süreci ve kaynak kümesini (K1) verir. 6.2'de filtreden kaynak kriteri kalktığı için eski
 * `datasourceId` hep boş gidiyordu. Düğüm yoksa (eski satır) filtredeki süreçle eski davranış.
 */
const idOf = (x) => (x && x._id ? x._id : x) || undefined;

export const recommendationContext = (editedDatasubject, criteria = {}) => ({
  processDataId: idOf(editedDatasubject?.processData),
  processId: idOf(criteria.process),
  datasubjectId: idOf(editedDatasubject) ?? idOf(criteria.datasubject),
});

export const processingLegalRecommendation = {
  state: {
    recommendations: null,
    showRecommendations: false,
  },
  getters: {
    recommendations: (state) => state.recommendations,
    showRecommendations: (state) => state.showRecommendations,
  },
  mutations: {
    recommendations: (state, value) => {
      state.recommendations = value;
    },
    showRecommendations: (state, value) => {
      state.showRecommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit, getters, rootGetters }, { pagination }) {
      commit("isLoading", true);
      try {
        const ctx = recommendationContext(getters.editedDatasubject, rootGetters["inventoryFilter/criteria"]);
        commit("recommendations", undefined);
        if (ctx.processDataId || ctx.processId) {
          const response = await rest.post(`/recommendation/paginate/process-data-datasubject-processing-legal`, { pagination, ...ctx });
          commit("recommendations", response.data);
          return response;
        }
      } finally {
        commit("isLoading", false);
      }
    },
  },
};

export const transferingLegalRecommendation = {
  state: {
    recommendations: null,
    showRecommendations: false,
  },
  getters: {
    showRecommendations: (state) => state.showRecommendations,
    recommendations: (state) => state.recommendations,
  },
  mutations: {
    recommendations: (state, value) => {
      state.recommendations = value;
    },
    showRecommendations: (state, value) => {
      state.showRecommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit, getters, rootGetters }, { pagination }) {
      commit("isLoading", true);
      try {
        const criteria = rootGetters["inventoryFilter/criteria"];
        const ctx = recommendationContext(getters.editedDatasubject, criteria);
        const receiverGroupId = idOf(criteria.receiverGroup);
        commit("recommendations", undefined);
        if (receiverGroupId && (ctx.processDataId || ctx.processId)) {
          const response = await rest.post(`/recommendation/paginate/process-data-datasubject-transfering-legal`, { pagination, receiverGroupId, ...ctx });
          commit("recommendations", response.data);
          return response;
        }
      } finally {
        commit("isLoading", false);
      }
    },
  },
};
